
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uiChangeSkladName } from '../../../actions/ui';
import PostingsApi from '../../../API/shipment/postings-api';
import WarehouseCommonApi from '../../../API/warehouse/common-api';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { DateInput, Input, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader } from '../../../components/Basic/Table';
import { H1, Text } from '../../../components/Basic/WrapsStyle';
import { SKLADS_WAREHOUSE } from '../../../constans';
import { MARKETS_LIST } from '../../Shipments/Shipment';
import WarehouseLine from './Line';
import styles from './styles.module.scss';

const FILTER = {
  0: 'debit_actions',
  1: 'debit_penalty',
  2: 'debit_archive',
};

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '100px', // 6
  '200px', // 7
  '100px', // 8
  '40px', // 9
  '90px', // 10
  '250px', // 11
  '170px', // 12
  '140px', // 13
  '500px', // 14
];
const CalcMonthAgo = () => {
  const start = new Date();
  start.setTime(start.getTime() - 30 * 24 * 3600000);

  return start;
};

const CalcFeatureTwoDay = () => {
  const start = new Date();
  start.setTime(start.getTime() + 2 * 24 * 3600000);
  return start;
};

const WarehousePage = () => {
  const [show, setShow] = useState(50);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [products, setProducts] = useState({ ids: [], byId: {} });

  const { skladName } = useSelector((store) => store.ui);

  const [count, setCount] = useState([]);
  const [countStock, setCountStock] = useState([0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ providerId: '' });
  const [checkAll, setCheckAll] = useState(false);

  const allProviders = useSelector((store) => store.providers);

  const [marketMany, setMarketMany] = useState(MARKETS_LIST[0]);
  const [shopName, setShopName] = useState('Все');
  const [providers, setProviders] = useState([]);

  const [historyDateFrom, setHistoryDateFrom] = useState(CalcMonthAgo());

  const dispatch = useDispatch();

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_select = {};
      postings.ids.forEach((item) => {
        map_select[postings.byId[item].posting_number] = true;
      });
      setProductsSelect(map_select);
      setCheckAll(true);
    } else {
      setCheckAll(false);
      setProductsSelect({});
    }
  };

  const [productsSelect, setProductsSelect] = useState({});

  const user = useSelector((store) => store.user);

  const params = useMemo(() => {
    return {
      search: search.trim(),

      providerId: provider.id,
      limit: parseInt(show),
      page,
      historyDateFrom,
      tab: FILTER[tab],
      skladName: skladName.short_name,
    };
  }, [search, show, page, tab, provider.id, skladName?.short_name]);

  const loadCards = () => {
    WarehouseCommonApi.getDebitActions({ data: params }).then((r) => {
      const { debit_actions, debit_archive, debit_penalty } = r.stock;

      const byIds = {};
      const id = r.data.map((item) => item.id);
      r.data.forEach((item) => (byIds[item.id] = item));

      setProducts({ byId: byIds, ids: id });
      setProductsSelect({});
      setCheckAll(false);
      setCountStock([debit_actions, debit_penalty, debit_archive]);

      setCount(r.stock.count);
    });

    return () => { };
  };

  const onChangeProduct = async (id, productId, field, value, action = undefined) => {
    await PostingsApi.changeProductInPosting({ data: { postingNumber: id, productId, field, value, action } }).then((r) => {
      setPostings({ ...postings, byId: { ...postings.byId, [r.posting.posting_number]: r.posting } });
    });
    loadCards();
  };

  useEffect(() => {
    loadCards();
  }, [params]);

  const onChangeTab = (n) => {
    setTab(n);
  };

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  const onChange = async (id, historyId, field, value, action) => {
    await WarehouseCommonApi.changeProduct({ data: { warehouseId: id, historyId, field, value, action, skladName: skladName.short_name } })
      .then((r) => {
        console.log(r);
        loadCards();
      })
      .catch();
  };

  const isOwner = user.role === 'owner' || user.role === 'admin';
  const isAdmin = isOwner || user.role === 'user';

  return (
    <Content>
      <H1>Проверка списаний со склада</H1>

      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={isAdmin ? ['Списания', 'Штрафы', 'Архив'] : ['Списания']}
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />
        </Row>

        <Row className={styles.row_input}>
          {Object.keys(productsSelect).length > 0 ? (
            <Row className={styles.row_select}>
              <Row>
                <Button
                  type={TYPE_BUTTONS.RED}
                  style={{ marginRight: '15px' }}
                  onClick={() => {
                    setCheckAll(false);
                    setPostingsPrint({});
                  }}
                >
                  Очистить выбор
                </Button>
              </Row>
            </Row>
          ) : (
            <Input value={search} onBlur={(v) => setSearch(v)} onClickEnter={(v) => setSearch(v)} label="Поиск" />
          )}
        </Row>
        <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>
        <Row spaceBetween={true}>
          <Row style={{ height: '40px' }}>
            <div>
              <Select
                label="Показать на странице"
                select={show}
                list={['20', '50', '100', '150', '200', '500', '1000']}
                onSelect={(v) => setShow(v)}
                width="150px"
                style={{ marginRight: '15px' }}
              />
            </div>

            <div>
              <Select
                label="Город"
                select={skladName}
                list={SKLADS_WAREHOUSE.filter((item) => user.sklads[item.short_name])}
                valueFn={(p) => p.name}
                onSelect={(v) => dispatch(uiChangeSkladName(v))}
                width="200px"
                style={{ marginRight: '15px' }}
              />
            </div>

            <Select
              label="Поставщик"
              select={provider}
              valueFn={(p) => p.name}
              list={providers}
              width="200px"
              onSelect={(v) => changeProvider(v)}
              style={{ marginRight: '15px' }}
            />
          </Row>

          <Row>
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Начало периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput
                  value={historyDateFrom}
                  className={styles.calendar}
                  onChange={(v) => setHistoryDateFrom(new Date(v))}
                />
              </Row>
            </Column>
          </Row>
        </Row>
      </WhiteBlock>
      <Table styles={styles.table}>
        <TableHeader whiteHeader>
          <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>Фото</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[0]} centerText={true}>Артикул</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[1]}>Наименование</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
            Дата списания
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
            Количество
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
            Кто списал
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[11]} centerText={true}>
            Причина списания
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[11]} centerText={true}>
            Разбор полетов
          </HeaderTitle>
        </TableHeader>
        {products.ids.map((id) => {
          const item = products.byId[id];

          return item.debit_actions?.map((action) => (
            <WarehouseLine
              isAdmin={isAdmin}
              isOwner={isOwner}
              product={item}
              skladName={skladName.short_name}
              key={`${id}${action._id}`}
              width={WIDTH_POSTING}
              action={action}
              onChange={onChange}
            />
          ));
        })}
      </Table>
    </Content>
  );
};

export default WarehousePage;
